import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  // null identifies the personal workspace, mirroring the absent ?org param.
  lastWorkspaceOrgId: string | null;
  setLastWorkspaceOrgId: (orgId: string | null) => void;
};

// Remembers the workspace tab the user last viewed so returning to the library
// (e.g. from Magic) reopens it instead of snapping back to personal.
export const useLastWorkspace = createWithEqualityFn<State>()(
  persist(
    (set) => ({
      lastWorkspaceOrgId: null,
      setLastWorkspaceOrgId: (lastWorkspaceOrgId) =>
        set({ lastWorkspaceOrgId }),
    }),
    {
      name: '_ah_last_workspace',
    }
  ),
  shallow
);
